var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 19.2C12.8835 19.2 13.6 19.9163 13.6 20.8V22.4C13.6 23.2837 12.8835 24 12 24C11.1164 23.9999 10.4 23.2836 10.4 22.4V20.8C10.4 19.9164 11.1164 19.2001 12 19.2Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.59141 17.1594C5.21974 16.6469 6.14627 16.6832 6.73203 17.2688C7.3569 17.8936 7.3569 18.9072 6.73203 19.532L5.13203 21.132C4.50722 21.7565 3.49428 21.7566 2.86953 21.132C2.24468 20.5072 2.24468 19.4936 2.86953 18.8687L4.46953 17.2688L4.59141 17.1594Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2695 17.2688C17.8943 16.6441 18.9073 16.6441 19.532 17.2688L21.132 18.8687C21.757 19.4936 21.757 20.5072 21.132 21.132C20.5073 21.7566 19.4943 21.7566 18.8695 21.132L17.2695 19.532C16.6447 18.9072 16.6447 17.8936 17.2695 17.2688Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5.6C15.5345 5.6 18.4 8.46542 18.4 12C18.3999 15.5345 15.5344 18.4 12 18.4C8.46554 18.3999 5.60011 15.5345 5.6 12C5.6 8.46546 8.46547 5.60006 12 5.6ZM12 8.8C10.2327 8.80007 8.8 10.2328 8.8 12C8.80011 13.7671 10.2328 15.1999 12 15.2C13.7672 15.2 15.1999 13.7672 15.2 12C15.2 10.2328 13.7673 8.8 12 8.8Z",
    fill: "current"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.2 10.4C4.08364 10.4 4.8 11.1163 4.8 12C4.79989 12.8836 4.08358 13.6 3.2 13.6H1.6C0.716435 13.6 0.000108019 12.8836 0 12C0 11.1163 0.716369 10.4 1.6 10.4H3.2Z",
    fill: "current"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4 10.4C23.2835 10.4 24 11.1163 24 12C23.9999 12.8836 23.2835 13.6 22.4 13.6H20.8C19.9164 13.6 19.2001 12.8836 19.2 12C19.2 11.1163 19.9164 10.4 20.8 10.4H22.4Z",
    fill: "current"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.86953 2.86953C3.49436 2.2447 4.5072 2.2447 5.13203 2.86953L6.73203 4.46953C7.35683 5.09437 7.35686 6.10721 6.73203 6.73203C6.1072 7.35666 5.0943 7.35675 4.46953 6.73203L2.86953 5.13203C2.24477 4.50725 2.24489 3.49438 2.86953 2.86953Z",
    fill: "current"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8695 2.86953C19.4944 2.24468 20.5072 2.24468 21.132 2.86953C21.7568 3.4944 21.7569 4.50724 21.132 5.13203L19.532 6.73203C18.9072 7.35671 17.8943 7.3567 17.2695 6.73203C16.6448 6.10723 16.6448 5.09437 17.2695 4.46953L18.8695 2.86953Z",
    fill: "current"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C12.8835 0 13.6 0.716309 13.6 1.6V3.2C13.6 4.08367 12.8835 4.8 12 4.8C11.1164 4.79994 10.4 4.08358 10.4 3.2V1.6C10.4 0.716402 11.1164 6.47306e-05 12 0Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.de3acb998fb275f266665cd26915f962.svg";
export { ForwardRef as ReactComponent };